import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import Cookie from 'cookie-universal';
import { Axios } from '../API/Axios';
import { CART } from '../API/Api';

const cookieJar = Cookie();

// ⚠️ CART جايه من API/Api.js وهي أصلاً فيها "/" في الأول ("/cart")
// عشان كده مش بنضيف "/" تاني قبلها في أي مكان هنا

const CartContext = createContext( null );

export const CartChangercontext = ( { children } ) =>
{
    const [ cart, setCart ] = useState( [] );
    const [ loading, setLoading ] = useState( false );
    // سبنا menuischange زي ما هي عشان أي كود قديم لسه بيستخدمها كإشارة تحديث
    const [ menuischange, setMenuischange ] = useState( true );

    const isLoggedIn = () => !!cookieJar.get( 'ecommerce' );

    const fetchCart = useCallback( async () =>
    {
        if ( !isLoggedIn() )
        {
            setCart( [] );
            return;
        }
        setLoading( true );
        try
        {
            const res = await Axios.get( CART );
            setCart( res.data );
        } catch ( error )
        {
            console.log( 'Error fetching cart:', error );
        } finally
        {
            setLoading( false );
        }
    }, [] );

    useEffect( () =>
    {
        fetchCart();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ menuischange ] );

    // بترجع { success: true } أو { success: false, reason: 'auth' | 'stock' | 'error' }
    // القرار في اللي بيستدعيها (يوجّه لـ /auth مثلاً) — الكونتكست ده مش جوه الراوتر
    // فمينفعش يعمل navigate بنفسه
    async function addToCart ( productId, count = 1 )
    {
        if ( !isLoggedIn() )
        {
            return { success: false, reason: 'auth' };
        }

        try
        {
            await Axios.post( `${ CART }/add`, { product_id: productId, count } );
            setMenuischange( ( prev ) => !prev );
            return { success: true };
        } catch ( error )
        {
            if ( error.response?.status === 422 )
            {
                return { success: false, reason: 'stock', available: error.response.data.available };
            }
            return { success: false, reason: 'error' };
        }
    }

    async function updateCartItem ( cartItemId, count )
    {
        try
        {
            await Axios.put( `${ CART }/${ cartItemId }`, { count } );
            setMenuischange( ( prev ) => !prev );
        } catch ( error )
        {
            console.log( 'Error updating cart item:', error );
        }
    }

    async function removeFromCart ( cartItemId )
    {
        try
        {
            await Axios.delete( `${ CART }/${ cartItemId }` );
            setMenuischange( ( prev ) => !prev );
        } catch ( error )
        {
            console.log( 'Error removing cart item:', error );
        }
    }

    async function clearCart ()
    {
        try
        {
            await Axios.delete( CART );
            setMenuischange( ( prev ) => !prev );
        } catch ( error )
        {
            console.log( 'Error clearing cart:', error );
        }
    }

    return (
        <CartContext.Provider value={ {
            cart,
            loading,
            menuischange,
            setMenuischange,
            isLoggedIn,
            addToCart,
            updateCartItem,
            removeFromCart,
            clearCart,
        } }>
            { children }
        </CartContext.Provider>
    );
};

export function useCart ()
{
    return useContext( CartContext );
}

export default CartContext;
